import { useEffect, useRef, useState } from 'react';
import themeCss from '../dashboard-demo.css?inline';
import {createPortal} from 'react-dom';
import InsightPanel from '../InsightPanel.jsx';
import '../insights.css';
import { SERIES } from '../../../shared/styles/tokens.js';

const seriesTokens = Object.fromEntries(SERIES.map((color,i)=>['--demo-series-'+i,color]));

export default function LegacyPage({ page }) {
  const ref = useRef(null);
  const [insight, setInsight] = useState(null);
  const [loaded, setLoaded] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setLoaded(null); setError(false);
    page.load().then(result => { if (active) setLoaded(result); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [page, attempt]);
  useEffect(() => {
    const root = ref.current;
    if (!root || !loaded) return;
    setInsight(null);
    root.innerHTML = loaded.MARKUP;
    const publish = event => {
      const selection = event.detail;
      const target = root.querySelector(selection.dataset ? '[data-insight-slot="'+selection.dataset+'"]' : '[data-insight-slot]');
      if (target) setInsight(previous => previous?.target === target && JSON.stringify(previous.selection) === JSON.stringify(selection) ? previous : {target, selection});
    };
    root.addEventListener('dashboard-insights-context', publish);
    root.querySelector('.topnav')?.remove();
    let cleanup;
    try { cleanup = loaded.mount(root); }
    catch (err) { console.error('Dashboard mount failed', err); setError(true); }
    return () => { root.removeEventListener('dashboard-insights-context', publish); cleanup?.(); root.innerHTML = ''; };
  }, [loaded]);
  return (
    <main className="o-page o-dashboard" style={seriesTokens}>
      {!loaded && !error && <p className="o-state" role="status">Loading dashboard...</p>}
      {error && <div className="o-state o-error" role="alert">Unable to load this dashboard. <button className="o-btn" onClick={() => setAttempt(n => n + 1)}>Retry</button></div>}
      {loaded && <style>{loaded.STYLE + themeCss}</style>}
      <div ref={ref} />
      {insight && createPortal(<InsightPanel selection={insight.selection}/>, insight.target)}
    </main>
  );
}
